import axios from "axios";
import React, { useEffect, useState } from "react";

// table-next
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import BoostrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { Button, Modal } from "react-bootstrap";
import { HttpJsonHeader } from "../../features/Environments";
import { setReminder } from "../../features/UserActions";
import { ModalHeaderBlack, MyModal } from "../../features/RadConnStyle";
import { FormSelectBlack, PageOptionsPvNx } from "../components/PageParams";

const SearchBrchGoodPopup = (props) => {
  const userDetail = useSelector((state) => state.user.detail);
  const [winState, setWinState] = props.winState;
  const { selectedRow, formName } = props;
  const [data, setData] = useState(null);
  const [good, setGood] = useState([]);
  const [dataFlw, setDataFlw] = useState([]);
  const [rowsEdited, setRowEdited] = useState([]);
  const dispatch = useDispatch();
  // const formName = "รายการสินค้าบริการสาขา";
  const [params, setParams] = props.params;
  const itemType = {
    PATRIGHT: 1,
    CATEGORY: 2,
    MODALITY: 3,
    SPECIALTY: 4,
    SPCSUB: 5,
  };
  //----------------------------------------------------------------------
  useEffect(() => {
    if (winState.show) {
      refreshGoods();
    }
  }, [winState]);

  //----------------------------------------------------------------------
  const refreshGoods = () => {
    axios
      .post(
        process.env.REACT_APP_API +
          "api/goodbranch/get-branch-pricelist-detail",
        {
          UserInfo: userDetail,
          SearchInfo: params,
          PricelistInfo: { price_list_id: params.price_list_id },
        },
        HttpJsonHeader
      )
      .then((res) => {
        res.data && setGood(res.data.rows);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  //----------------------------------------------------------------------
  useEffect(() => {
    axios
      .post(
        process.env.REACT_APP_API + "api/goods/selected-lists",
        { UserInfo: userDetail, SearchTxt: "" },
        HttpJsonHeader
      )
      .then((res) => {
        res.data && setDataFlw(res.data);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  }, [winState]);

  //----------------------------------------------------------------------
  const msgbox = (text) => {
    dispatch(setReminder({ show: true, message: text, type: "success" }));
  };
  //----------------------------------------------------------------------
  const getHeaderStyle = (wi) => {
    return {
      width: wi,
      background: "var(--table-header-back-color)",
    };
  };
  //----------------------------------------------------------------------
  const customTextFilter = {
    placeholder: "...",
  };
  //----------------------------------------------------------------------
  const changeParams = (iType, e) => {
    let refresh = false;
    switch (iType) {
      case itemType.CATEGORY:
        if (params.goodcateid === e.target.value) break;
        setParams((pv) => {
          return { ...pv, goodcateid: e.target.value };
        });
        refresh = true;
        break;
      case itemType.SPECIALTY:
        if (params.gdspecialtyid === e.target.value) break;
        setParams((pv) => {
          return { ...pv, gdspecialtyid: e.target.value };
        });
        refresh = true;
        break;
      case itemType.SPCSUB:
        if (params.gdspcsubid === e.target.value) break;
        setParams((pv) => {
          return { ...pv, gdspcsubid: e.target.value };
        });
        refresh = true;
        break;
      case itemType.MODALITY:
        if (params.gdmodid === e.target.value) break;
        setParams((pv) => {
          return { ...pv, gdmodid: e.target.value };
        });
        refresh = true;
        break;
      default:
        break;
    }
    if (refresh) {
      refreshGoods();
    }
  };

  //-------------------Columns ราคา ----------------------------------------
  const colPrice = [
    {
      dataField: "goodcode",
      text: "รหัส",
      sort: true,
      headerStyle: () => getHeaderStyle("100px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
        paddingLeft: "20px",
      },
      filter: textFilter(customTextFilter),
      editable: false,
    },
    {
      dataField: "goodname",
      text: "สินค้า-บริการ",
      sort: true,
      headerStyle: () => getHeaderStyle("auto"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
        paddingLeft: "20px",
      },
      filter: textFilter(customTextFilter),
      editable: false,
    },
    {
      dataField: "price",
      text: "ราคา",
      sort: true,
      headerStyle: () => getHeaderStyle("120px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "right",
      },
      filter: textFilter(customTextFilter),
      formatter: (cell, row) => {
        return Number(cell).toLocaleString("th-TH", {
          style: "decimal",
          minimumFractionDigits: 2,
        });
      },
    },
    {
      dataField: "none",
      text: "-",
      headerStyle: () => getHeaderStyle("40px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "center",
      },
      editable: false,
    },
  ];

  //----------------------------------------------------------------------
  const tbRowEvents = {
    // onClick : {.....}
    onDoubleClick: (e, row, rowIndex) => {
      e.preventDefault();
      winState.action(row, [setWinState]);
    },
  };

  return (
    <MyModal
      show={winState.show}
      size="lg"
      centered
      backdrop={false}
      onHide={() => setWinState({ show: false })}
    >
      <ModalHeaderBlack style={{ textAlign: "center" }} closeButton>
        ค้นหาสินค้า-บริการสาขา {`${formName ? formName : "รายการ"}`}
      </ModalHeaderBlack>
      <VBox>
        {/* ---------------------------------------------------------- */}
        <HBox>
          <VBox>
            <HBox>
              <SBox>
                ประเภทสินค้า:
                <FormSelectBlack
                  style={{ color: "var(--select-item-color)" }}
                  aria-label="ตัวเลือก"
                  // leadtype="all"
                  addFirstRow={true}
                  firstRowText="ทั้งหมด"
                  name={"goodCateId"}
                  rows={dataFlw && dataFlw.GoodCate}
                  onChange={(e) => {
                    changeParams(itemType.CATEGORY, e);
                  }}
                />
              </SBox>
              <SBox>
                Modality:
                <FormSelectBlack
                  style={{ color: "var(--select-item-color)" }}
                  aria-label="ตัวเลือก"
                  // leadtype="all"
                  addFirstRow={true}
                  firstRowText="ทั้งหมด"
                  name={"goodModalityId"}
                  rows={dataFlw && dataFlw.GoodModality}
                  onChange={(e) => {
                    changeParams(itemType.MODALITY, e);
                  }}
                />
              </SBox>
              <SBox>
                Specialty:
                <FormSelectBlack
                  style={{ color: "var(--select-item-color)" }}
                  aria-label="ตัวเลือก"
                  // leadtype="all"
                  addFirstRow={true}
                  firstRowText="ทั้งหมด"
                  name={"goodspc"}
                  rows={dataFlw && dataFlw.GoodSpc}
                  onChange={(e) => {
                    changeParams(itemType.SPECIALTY, e);
                  }}
                />
              </SBox>
              <SBox>
                Sub Specialty:
                <FormSelectBlack
                  style={{ color: "var(--select-item-color)" }}
                  aria-label="ตัวเลือก"
                  // leadtype="all"
                  name={"subspc"}
                  addFirstRow={true}
                  firstRowText="ทั้งหมด"
                  rows={dataFlw && dataFlw.GoodSpcSub}
                  onChange={(e) => {
                    changeParams(itemType.SPECIALTY, e);
                  }}
                />
              </SBox>
            </HBox>
            {/* -------------------------------------------------------------- */}
            <BoostrapTable
              bootstrap4
              keyField="price_list_det_id"
              rowClasses={"table-next-rows-style"}
              data={good}
              columns={colPrice}
              striped
              hover
              condensed
              headerWrapperClasses="headerWrapper"
              wrapperClasses="bs-table-wrapper"
              bordered={true}
              pagination={paginationFactory(PageOptionsPvNx)}
              filter={filterFactory()}
              rowEvents={tbRowEvents}
            />
          </VBox>
        </HBox>
      </VBox>
    </MyModal>
  );
};

const HBox = styled.div`
  flex: 1;
  display: flex;
`;

const VBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: var(--bg-primary);
`;

const SBox = styled.div`
  color: var(--caption-fore-color);
  margin: 5px;
  flex: 1;
`;

export default SearchBrchGoodPopup;
